/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_I$ as I$,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
} from "../../runtime/index.jsx";
export function Componente_LDolar_76_36() {
  return I$.map((e, t) => (
    <span key={t} className={`confeti`} style={e} aria-hidden={`true`} />
  ));
}
